import { withStyles } from "@material-ui/core";
import React from "react";
import Header from "./Header";

const styles = (theme) => ({
  message: {
    color: theme.errorBorderColor,
    fontSize: theme.dispatchCardTextFontSize,
  },
  errorContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    marginTop: 16,
  },
});

const Error = ({ message, classes }) => (
  <div className={classes.errorContainer}>
    <Header label="Error : "/>
    <div className={classes.message}>{message}</div>
  </div>
);

export default withStyles(styles)(Error);
